import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { EChartsOption, GaugeSeriesOption } from "echarts";
import * as echarts from "echarts";
import * as data from "../dashboard-ostetrica/data.json";
import { HappyMammaService } from "@hm_app/@core/data/happymamma.service";
import { AuthUser } from "@hm_app/@core/models/auth_user";

export enum BlockType {
	synthesis = "synthesis",
	chart = "chart",
}

export interface JSONDashboardData {
	title: TextInterface;
	description: TextInterface;
	blocks: BlockInterface[];
}

export interface TextInterface {
	key?: string;
	text: string | number;
	fontSize: number;
	fontWeight: string;
	color: string;
}

export interface BlockInterface {
	key?: string;
	tpye: BlockType;
	icon?: IconInterface;
	title: TextInterface;
	subtitle?: TextInterface;
	hintText: TextInterface;
	numberTotals?: NumberTotalInterface[];
	percentTotal?: PercentTotalInterface;
}

export interface NumberTotalInterface {
	title: TextInterface;
	value: TextInterface;
}

export interface PercentTotalInterface {
	title: TextInterface;
	value: TextInterface;
	stats: NumberTotalInterface[];
}

export interface IconInterface {
	class: string;
	size: number;
	color: string;
	backgroundColor: string;
}

export interface ChartEntry {
	title: string;
	cartacei: number;
	digitali: number;
}

export interface Stats {
	chart_azienda: ChartEntry[];
	chart_self: ChartEntry[];
	distretto_cartacei: number;
	distretto_digitali: number;
	distretto_libretti: number;
	distretto_percent_azienda: string;
	distretto_percent_total: number;
	self_azienda: string;
	self_cartacei: number;
	self_digitali: number;
	self_distretto: string;
	self_libretti: number;
	self_percent_azienda: string;
	self_percent_distretto: string;
	self_percent_total: number;
}

@Component({
	selector: "ngx-dashboard-ostetrica",
	templateUrl: "./dashboard-ostetrica.component.html",
	styleUrls: ["./dashboard-ostetrica.component.scss"],
})
export class DashboardOstetricaComponent implements OnInit, AfterViewInit {
	jsonData: JSONDashboardData;
	blockTypes = BlockType;

	@Input() auth_user: AuthUser;

	@Input() stats: Stats;

	constructor(private hmService: HappyMammaService) {}

	async ngOnInit() {
		this.jsonData = data["default"];
	}

	ngAfterViewInit(): void {
		this.jsonData.blocks.forEach((b, index) => {
			if (b["type"] == this.blockTypes.chart) {
				var dom = document.getElementById("barchart_" + index);
				var myChart = echarts.init(dom);
				myChart.setOption(this.generateBarChartOptions(b));
			}
		});
	}

	getTextStyle(block: TextInterface) {
		let style: string = "";
		style += "font-size:" + block.fontSize + "px;";
		style += "font-weight:" + block.fontWeight + ";";
		style += "color:" + block.color + ";";
		return style;
	}

	getIconStyle(block: IconInterface) {
		let style: string = "";
		style += "font-size:" + block.size + "px;";
		style += "color:" + block.color + ";";
		style += "background-color:" + block.backgroundColor + ";";
		return style;
	}

	generateGaugeOptions(block: PercentTotalInterface) {
		let option: EChartsOption = {};
		let series: GaugeSeriesOption = {
			type: "gauge",
			radius: "100%",
			startAngle: 90,
			endAngle: -270,
			pointer: {
				show: false,
			},
			progress: {
				show: true,
				overlap: false,
				roundCap: true,
				clip: false,
				itemStyle: {
					color: "#50AFAE",
				},
			},
			axisLine: {
				lineStyle: {
					width: 4,
				},
			},
			splitLine: {
				show: false,
			},
			axisTick: {
				show: false,
			},
			axisLabel: {
				show: false,
			},
			data: [
				{
					value: block.value.key
						? this.stats[block.value.key]
						: (block.value.text as number),
					detail: {
						valueAnimation: true,
						offsetCenter: ["0%", "-0%"],
					},
				},
			],
			detail: {
				fontSize: block.value.fontSize,
				color: block.value.color,
				fontWeight: "normal",
				formatter: "{value}%",
			},
		};

		option.series = series;
		return option;
	}

	generateBarChartOptions(block: BlockInterface) {
		let source = [
			{
				"area vasta": "USL Toscana Nord Ovest ",
				"Libretti Digitali": 50,
				"Libretti Cartacei": 50,
			},
			{
				"area vasta": "USL Toscana Centro ",
				"Libretti Digitali": 80,
				"Libretti Cartacei": 20,
			},
			{
				"area vasta": "USL Toscana Sud Est ",
				"Libretti Digitali": 30,
				"Libretti Cartacei": 70,
			},
		];

		if (block.key) {
			source = (this.stats[block.key] as ChartEntry[]).map((e) => {
				return {
					"area vasta": e.title.replace("Azienda", ""),
					"Libretti Digitali": e.digitali,
					"Libretti Cartacei": e.cartacei,
				};
			});
		}

		let options: EChartsOption = {
			legend: {
				bottom: 0,
				itemGap: 100,
			},
			tooltip: {},
			dataset: {
				dimensions: [
					"area vasta",
					"Libretti Digitali",
					"Libretti Cartacei",
				],
				source: source,
			},
			xAxis: {
				type: "category",
				axisLabel: {
					interval: 0,
					fontSize: 10,
				},
			},
			yAxis: {
				max: 100,
				axisLabel: {
					formatter: "{value}%",
				},
			},
			series: [
				{
					type: "bar",
					stack: "total",
					barWidth: 20,
					barGap: 1,
					itemStyle: { color: "#50AFAE" },
				},
				{
					type: "bar",
					stack: "total",
					barWidth: 20,
					barGap: 1,
					itemStyle: { color: "#F4A62A" },
				},
			],
		};
		return options;
	}

	isPillNegativeClass(stat: PercentTotalInterface) {
		var valueNumber = stat.value.text;
		if (stat.value.key) {
			valueNumber = this.stats[stat.value.key];
		}
		return valueNumber.toString().startsWith("-");
	}
}
